export default __webpack_public_path__ + "img/flow.76414ed6.webp";